import http from "./http-common";

class enrollmentServices {
  Invite(data) {
    return http.post(`/invitationDetails/save`, data);
  }
  InviteForOtherCountry(data) {
    return http.post(`/invitationDetails/saveWithoutDp`, data);
  }

  InviteLinkMaster(id) {
    return http.get(`/inviteLinkMaster/list/filter?userId=${id}`);
  }

  InvitationShare(data) {
    return http.post(`/invitationDetails/invitationLink`, data);
  }

  CheckFollowUp(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
    return http.get(
      `/patientAppointment/appointmentValidateForDiscount?${queryString}`,
    );
  }

  PatientList(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
    return http.get(`/patient/list/filter?${queryString}`);
  }

  StateMaster() {
    return http.get(`/stateMaster/list/filter?status=1`);
  }

  sharePaymentLink(data) {
    return http.post(`/invitationDetails/sharepaymentlink`, data);
  }
}

export default new enrollmentServices();
